import {Component, OnInit} from "@angular/core";
import {HttpClientService} from "../../../../core/services/http-client.service";
import {ToastService} from "../../../../core/services/toast.service";
import {CommonService} from "../../../../core/services/common.service";
import {ActivatedRoute, Router} from "@angular/router";
import {Capacitor} from "@capacitor/core";
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';

@Component({
  selector: 'app-orders',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.css']
})
export class DetailsComponent implements OnInit{

  order:any={}
  events = [
    { status: 'Ordered', date: '22 Dec 2024' },
    { status: 'Shipped', date: '23 Dec 2024' },
    { status: 'Out of Delivery', date: '23 Dec 2024' },
    { status: 'Delivered', date: '25 Dec 2024' }
  ];
  customer: any;
  private user: any;
  shippingAddress: any;
  totalAmount: any=0;
  subtotal: any=0;
  shipping: number=0;
  grandTotal: number=0;
  pendingOrderItems: any[] = [];
  addresses: any[];
  storeaddres:any;
  private orderId: any;
  codFee: number = 0;
  promotionDiscount: number = 0;
  constructor(private http: HttpClientService, private toast: ToastService,private store: CommonService,private route: ActivatedRoute,private router: Router) {
    this.customer = this.store.getStorage('customer');
  }

  ngOnInit() {
    this.orderId = this.route.snapshot.paramMap.get('id') || '';
    this.user = this.store.getStorage('customer');
    this.fetchOrder();
  }
  private fetchOrder() {
    this.http.get(`store/order-status/${this.orderId}`).subscribe(
      (res) => {
        if (res.statusCode === "200") {
          this.order = res.response;
          this.pendingOrderItems = this.order.pendingOrderItems || [];
          this.calculate('total');
          this.calculate('payment');
          this.getUserAddresses(this.order.customerId);
          this.storeAddress();
        } else {
          console.error('Failed to fetch orders:', res.statusMessage);
        }
      },
      (error) => {
        console.error('Error fetching orders:', error);
      }
    );
  }
  private storeAddress(){
    this.http.get('/store/address').subscribe(
      (res)=>{
        if(res.statusCode === "200") this.storeaddres = res.response;
        else console.error('Failed to fetch orders:', res.statusMessage);
      },
      (error) => {
        console.error('Error fetching store address:', error);
      }
    )
  }
  private calculate(type) {
    if (type == 'total') {
      this.subtotal = this.pendingOrderItems.reduce((sum, item) => sum + item.sellingPrice, 0);
    }
    if (type == 'payment') {
      this.grandTotal = this.subtotal + this.codFee - this.promotionDiscount;
    }
  }

  downloadInvoice(){
    this.http.downloadFile("store/generateInvoice?orderId="+this.orderId,'application/pdf')
      .subscribe((blob:any) => {
        const fileName = `${this.orderId}-invoice.pdf`;
        if (Capacitor.isNativePlatform()) {
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = async () => {
            const base64Data = reader.result?.toString().split(',')[1];
            await Filesystem.writeFile({
              path: fileName,
              data: base64Data!,
              directory: Directory.Documents
            });

            const fileUri = await Filesystem.getUri({
              directory: Directory.Documents,
              path: fileName
            });
            console.log("File saved at:", fileUri.uri);
            alert("Invoice downloaded successfully!");
          };
        } else {
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
        }
      }, error => {
        if (error.statusCode == 400) {
          this.toast.error(error.response.message)
          console.log("error", error)
        }
        else {
          console.log("error", error)
          this.toast.error("Something went wrong")
        }
      });
  }
  private getUserAddresses(userID: number) {
    this.http.get(`store/addresses/${userID}`).subscribe(
      (res) => {
        if (res.statusCode == 200) {
          this.addresses = [];
          for (let address of res.response) {
            address.fullAddress = this.getFullAddress(address);
            this.addresses.push(address);
          }
          this.getShippingAddress(this.order.customerAddressId);
        }
      },
      (error) => {
        console.error('Error fetching user addresses:', error);
      }
    );
  }

  getShippingAddress(customerAddressId: number) {
    const matchedAddress = this.addresses.find(addr => addr.id === customerAddressId);
    if (matchedAddress) {
      this.shippingAddress = { name: matchedAddress.name || 'N/A',
        line1: matchedAddress.line1 || 'N/A',
        line2: matchedAddress.line2 || 'N/A',
        landmark: matchedAddress.landmark || 'N/A',
        city: matchedAddress.city || 'N/A',
        state: matchedAddress.state || 'N/A',
        pinCode: matchedAddress.pinCode || 'N/A',
        country: matchedAddress.country || 'India',
        phoneNumber: matchedAddress.phoneNumber || 'N/A'};
    } else {
      console.error('No matching address found for customerAddressId:', customerAddressId);
    }
  }

  private getFullAddress(address: any): string {
    let add = '';
    add += address.line1 ? address.line1 + ', ' : '';
    add += address.line2 ? address.line2 + ', ' : '';
    add += address.landmark ? address.landmark + ', ' : '';
    add += address.city ? address.city + ', ' : '';
    add += address.state ? address.state + ', ' : '';
    add += address.pinCode ? address.pinCode : '';
    return add;
  }

  navigateToProductDetail(productId: string) {
    if(productId) this.router.navigate([`product/${productId}`]);
  }
}
